import axios from 'axios';
import { formatToYMD } from '../../../_mexablock/helpers';
const API_URL = process.env.REACT_APP_API;

export async function getConsumption(body: any) {
  const { msisdn, iccid } = body;

  const data = {
    msisdn: msisdn,
    iccid: iccid,
  };
  const response = await axios.post(`${API_URL}consumption/`, data);
  return response;
}

export async function getConsumptionData(body: {
  msisdn?: string;
  iccid?: string;
}) {
  const { msisdn, iccid } = body;

  let type = '';
  let value = '';

  if (msisdn) {
    type = 'msisdn';
    value = msisdn;
  } else if (iccid) {
    type = 'iccid';
    value = iccid;
  } else {
    throw new Error('Debe proporcionar msisdn o iccid');
  }
  const response = await axios.get(
    `${API_URL}consumption/info/${type}/${value}`
  );
  return response;
}

type ConsumptionQueryParams = {
  type: 'msisdn' | 'iccid';
  value: string;
  init_date?: string;
  end_date?: string;
  offer_id?: number;
};

export async function getConsumptionByDate({
  type,
  value,
  init_date,
  end_date,
  offer_id,
}: ConsumptionQueryParams) {
  if (!type || !value) {
    throw new Error('"tipo" y "valor" son requeridos');
  }

  let url = `${API_URL}consumption/by-date/${type}/${value}`;
  const query: string[] = [];

  if (init_date) query.push(`init_date=${formatToYMD(init_date)}`);
  if (end_date) query.push(`end_date=${formatToYMD(end_date)}`);
  if (offer_id !== undefined) query.push(`offer_id=${offer_id}`);

  if (query.length > 0) {
    url += `?${query.join('&')}`;
  }
  const { data } = await axios.get(url);
  return data;
}

export async function getConsumptionByAPP({
  type,
  value,
  init_date,
  end_date,
  offer_id,
}: ConsumptionQueryParams) {
  if (!type || !value) {
    throw new Error('"tipo" y "valor" son requeridos');
  }

  let url = `${API_URL}consumption/by-app/${type}/${value}`;
  const query: string[] = [];

  if (init_date) query.push(`init_date=${formatToYMD(init_date)}`);
  if (end_date) query.push(`end_date=${formatToYMD(end_date)}`);
  if (offer_id !== undefined) query.push(`offer_id=${offer_id}`);

  if (query.length > 0) {
    url += `?${query.join('&')}`;
  }
  const { data } = await axios.get(url);
  return data;
}
